/* eslint-disable class-methods-use-this */

export default class ParentSubscriber {
  subscribe() {
  }
}
